// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import AchievementType from "./achievement_type_type";


export default __t.object("Achievement", {
  id: __t.u64(),
  userId: __t.u64(),
  get achievementType() {
    return AchievementType;
  },
  unlockedAt: __t.u64(),
});


